import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusDoubleCircleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	x: "0px",
	y: "0px",
	viewBox: "0 0 21 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n    .plus_double_circle_icon-st0{fill:none;stroke:currentColor;stroke-width:1.8}\n    .plus_double_circle_icon-st1{fill:currentColor}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plus_double_circle_icon-st0",
			d: "M10.5 1.66809C9.73041 1.34715 8.8859 1.16992 8 1.16992C4.41015 1.16992 1.5 4.08007 1.5 7.66992C1.5 11.2598 4.41015 14.1699 8 14.1699C8.7631 14.1699 9.49549 14.0384 10.1757 13.7968"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plus_double_circle_icon-st1",
			d: "M13.8333 4.33659H12.1667V6.83659H9.66667V8.50325H12.1667V11.0033H13.8333V8.50325H16.3333V6.83659H13.8333V4.33659ZM13 0.169922C8.86667 0.169922 5.5 3.53659 5.5 7.66992C5.5 11.8033 8.86667 15.1699 13 15.1699C17.1333 15.1699 20.5 11.8033 20.5 7.66992C20.5 3.53659 17.1333 0.169922 13 0.169922ZM13 13.5033C9.78333 13.5033 7.16667 10.8866 7.16667 7.66992C7.16667 4.45326 9.78333 1.83659 13 1.83659C16.2167 1.83659 18.8333 4.45326 18.8333 7.66992C18.8333 10.8866 16.2167 13.5033 13 13.5033Z"
		})
	]
});
export default SvgPlusDoubleCircleIcon;
